import clsx from 'clsx';
import React, { Component } from 'react';

class NoParamsPlaceholder extends Component {
  render() {
    return (
      <div className={clsx('text-center', 'mt-10')} data-parameters="noparams">
        <div className="pt-10">
          <span className={clsx('icon-bzm-info', 'icon-xlg', 'icon-theme-gray-50')} aria-hidden="true" />
        </div>
        <div className={clsx('h4', 'pt-2', 'font-weight-semi-bold')}>Add Global Scope Param</div>
        <div className={clsx('pt-3', 'pb-10', 'px-3')}>
          Click the Plus button to add Global Scope Parameter. You will be able to use global scope parameter within a
          virtual service. You can update initial value by state update webhook.
        </div>
      </div>
    );
  }
}

export default NoParamsPlaceholder;
